import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["strength-training-for-runners"]!;

export function Body() {
  return (
    <>
      <p>
        Should runners lift weights? Many worry that it will make them heavier or take time away
        from running. Two reviews of the research give a fairly clear answer.
      </p>

      <h2>What the researchers did</h2>
      <p>
        A 2018 review went through 24 studies of middle- and long-distance runners with at least
        six months of running experience. Each study added at least four weeks of heavy strength
        training, explosive strength training or jumping exercises, and compared it with a group
        that only ran.
      </p>
      <p>
        A 2016 meta-analysis looked specifically at highly trained runners with a maximal oxygen
        uptake above 60 ml/kg/min. Five studies with 93 runners met the criteria.
      </p>

      <h2>What they found</h2>
      <p>
        In most of the studies, strength training improved running economy, how much energy you
        use at a given pace, by 2 to 8 percent compared with running only. Time trials from 1.5
        to 10 km and sprint speed also tended to improve. Maximal oxygen uptake was usually
        unaffected, and body composition did not change for the worse.
      </p>
      <p>
        In the highly trained runners, the effect on running economy was large. The programmes
        typically used two to four lower-body exercises at low to moderate loads, plus jumps and
        short sprints, two to three times a week for 8 to 12 weeks.
      </p>

      <h2>What it means for you</h2>
      <p>
        Two or three short strength sessions a week can make you a more economical runner. A mix
        works well: heavy exercises such as squats or deadlifts, explosive exercises and jumps.
        Start with lighter loads and learn the technique.
      </p>
      <p>
        Place strength sessions away from your hardest runs, for example after an easy run or on
        a day without running, so they don't take the quality out of your key sessions.
      </p>

      <h2>What the studies can't tell you</h2>
      <p>
        The results were not the same in every study, and many studies were small. The meta-analysis
        included only five studies of highly trained runners. Whether strength training reduces
        injuries was not part of these reviews.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training plans your running. If you add strength training, place it so your harder
        runs can still be done well, and tell us when a session felt harder than expected.
      </p>

      <h2>Sources</h2>
      <ul>
        <li>
          Blagrove, Howatson & Hayes (2018), Effects of strength training on the physiological
          determinants of middle- and long-distance running performance: a systematic review.{" "}
          <a href="https://doi.org/10.1007/s40279-017-0835-7">Sports Medicine</a>.
        </li>
        <li>
          Balsalobre-Fernández, Santos-Concejero & Grivas (2016), Effects of strength training on
          running economy in highly trained runners: a systematic review with meta-analysis of
          controlled trials.{" "}
          <a href="https://doi.org/10.1519/JSC.0000000000001316">Journal of Strength and Conditioning Research</a>.
        </li>
      </ul>
    </>
  );
}
